//define a function
function hamburger__click() {
  if ($(".jsHamburger").length > 0) {
    $("header .jsHamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("is-menu-visible");
    });
    $(document).click(function (e) {
      var container = $("header");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parents("body").removeClass("is-menu-visible");
      }
    });
  }
}

//Image to SVG
function imgToSvg() {
  let convertImages = (_query, callback) => {
    let images = document.querySelectorAll("img.svg");
    images.forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser();
          let svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("width") +
              " " +
              svg.getAttribute("height"),
          );
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;
          image.parentNode.replaceChild(svg, image);
        })
        .then(callback);
    });
  };
  convertImages("img");
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  const header = $(".header");
  if (header.length === 0) return;

  const setStickyState = () => {
    const scrollTop = $(window).scrollTop();
    header.toggleClass("is-sticky", scrollTop > 10);
    lastScrollTop = scrollTop;
  };

  // Apply on load and whenever user scrolls.
  setStickyState();
  $(window).on("scroll", setStickyState);
};

function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

// faq accordion
function accordion__toggle() {
  if ($(".faq__accordion .accordion__title button").length > 0) {
    var accordionButtons = $(".faq__accordion .accordion__title button");

    function checkOthers(elem) {
      for (var i = 0; i < accordionButtons.length; i++) {
        if (accordionButtons[i] != elem) {
          if ($(accordionButtons[i]).attr("aria-expanded") == "true") {
            $(accordionButtons[i]).attr("aria-expanded", "false");
            var content = $(accordionButtons[i]).attr("aria-controls");
            $("#" + content).attr("aria-hidden", "true");
            $("#" + content).slideUp();
            $(accordionButtons[i])
              .closest(".accordion__item")
              .removeClass("is-open");
          }
        }
      }
    }

    $(".faq__accordion .accordion__title button").on("click", function () {
      var $control = $(this);
      var accordionContent = $control.attr("aria-controls");
      checkOthers($control[0]);

      var isAriaExp = $control.attr("aria-expanded");
      var newAriaExp = isAriaExp == "false" ? "true" : "false";
      $control.attr("aria-expanded", newAriaExp);

      var isAriaHid = $("#" + accordionContent).attr("aria-hidden");
      if (isAriaHid == "true") {
        $("#" + accordionContent).attr("aria-hidden", "false");
        $("#" + accordionContent).slideDown();
        $control.closest(".accordion__item").addClass("is-open");
      } else {
        $("#" + accordionContent).attr("aria-hidden", "true");
        $("#" + accordionContent).slideUp();
        $control.closest(".accordion__item").removeClass("is-open");
      }
    });
  }
}

function initScrollRevealTrigger() {
  function parseDataAttributes(element) {
    const options = {
      animationDuration: 1,
      delay: 0,
      triggerStart: "top 95%",
    };

    if (element.dataset.revealDuration) {
      options.animationDuration = parseFloat(element.dataset.revealDuration);
    }

    if (element.dataset.revealDelay) {
      options.delay = parseFloat(element.dataset.revealDelay) * 1000;
    }

    const triggerArea = element.getAttribute("trigger-area");
    if (triggerArea) {
      switch (triggerArea.toLowerCase()) {
        case "center":
          options.triggerStart = "center center";
          break;
        case "top":
          options.triggerStart = "top top";
          break;
        case "bottom":
          options.triggerStart = "bottom bottom";
          break;
        default:
          "top 85%";
          break;
      }
    }

    return options;
  }

  function initElements() {
    if (typeof ScrollTrigger === "undefined") {
      console.warn(
        "ScrollTrigger is not available. data-reveal-trigger will not work.",
      );
      return;
    }

    const allTriggerElements = document.querySelectorAll(
      "[data-reveal-trigger]",
    );

    // Only run reveal animation on viewports >= 1199px; on smaller devices show content immediately
    if (window.innerWidth < 1199) {
      allTriggerElements.forEach((el) => {
        gsap.set(el, {
          opacity: 1,
          y: 0,
          visibility: "visible",
          clearProps: "transform,opacity,visibility",
        });
      });
      return;
    }

    const triggerElements = Array.from(allTriggerElements).filter(
      (element) =>
        !element.classList.contains("is-revealed") ||
        !element.hasAttribute("data-reveal-trigger-initialized"),
    );

    if (triggerElements.length === 0) {
      return;
    }

    triggerElements.forEach((element) => {
      const options = parseDataAttributes(element);

      function isElementPastTrigger(element, triggerStart) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY || window.pageYOffset;
        const elementTop = rect.top + scrollY;
        const triggerPercent =
          parseFloat(triggerStart.split(" ")[1]) / 100 || 0.85;
        const triggerPoint = scrollY + windowHeight * triggerPercent;
        return elementTop < triggerPoint;
      }

      gsap.set(element, {
        opacity: 0,
        y: "50px",
        visibility: "visible",
        force3D: true,
        willChange: "transform, opacity",
        transformOrigin: "center center",
      });

      let scrollTriggerInstance = null;

      const animateElement = () => {
        gsap.to(element, {
          opacity: 1,
          y: "0px",
          duration: options.animationDuration,
          delay: options.delay / 1000,
          ease: "power2.out",
          force3D: true,
          onStart: () => {
            element.style.willChange = "transform, opacity";
            if (element.classList.contains("l-btn")) {
              element.style.transition = "none";
            }
          },
          onComplete: () => {
            element.style.willChange = "auto";

            const event = new CustomEvent("revealTriggered", {
              detail: { element },
              bubbles: true,
            });
            element.dispatchEvent(event);

            element.classList.add("is-revealed");

            if (scrollTriggerInstance) {
              scrollTriggerInstance.kill();
              scrollTriggerInstance = null;
            }
          },
        });
      };

      const isAlreadyVisible = isElementPastTrigger(
        element,
        options.triggerStart,
      );

      if (isAlreadyVisible) {
        animateElement();
      } else {
        scrollTriggerInstance = ScrollTrigger.create({
          trigger: element,
          start: options.triggerStart,
          end: "bottom 15%",
          once: true,
          markers: false,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onRefresh: function (self) {
            if (self.progress > 0 || self.isActive) {
              if (!element.classList.contains("is-revealed")) {
                animateElement();
              }
            }
          },
          onEnter: () => {
            animateElement();
          },
        });
      }

      element.setAttribute("data-reveal-trigger-initialized", "true");
    });
  }

  window.initScrollRevealTrigger = () => {
    initElements();
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  };

  initElements();
}

// Slide-up animation for .wrg.split-text containers.
// Animates only `y` (never opacity/visibility — split-text owns those).
// Fires at "top 98%" so the container lifts before split-text's line animation
// begins at "top 90%", creating a natural cascade.
function initSplitTextSlideUp() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }

  const containers = document.querySelectorAll(
    ".wrg.split-text:not([data-split-slide-initialized])",
  );

  if (window.innerWidth < 1198) {
    containers.forEach((el) => gsap.set(el, { clearProps: "y" }));
    return;
  }

  containers.forEach((container) => {
    gsap.set(container, { y: 25, force3D: true });

    const animate = () => {
      if (container.hasAttribute("data-split-slide-done")) return;
      container.setAttribute("data-split-slide-done", "true");
      gsap.to(container, {
        y: 0,
        duration: 0.7,
        ease: "power2.out",
        force3D: true,
      });
    };

    const rect = container.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.98) {
      animate();
    } else {
      ScrollTrigger.create({
        trigger: container,
        start: "top 98%",
        once: true,
        onEnter: animate,
        onRefresh: (self) => {
          if (self.progress > 0) animate();
        },
      });
    }

    container.setAttribute("data-split-slide-initialized", "true");
  });
}

function animateNumberReveal(selector) {
  const items = document.querySelectorAll(selector);
  if (items.length === 0) return;

  function getRandomCharacter() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    return chars.charAt(Math.floor(Math.random() * chars.length));
  }

  function animateNumbers(item) {
    if (item.hasAttribute("data-number-revealed")) return;
    item.setAttribute("data-number-revealed", "true");

    const targetText = item.innerText.trim();
    const digitsOnly = /^\d+$/.test(targetText);
    if (digitsOnly && typeof gsap !== "undefined") {
      const endVal = parseInt(targetText, 10);
      const state = { val: 0 };
      gsap.to(state, {
        val: endVal,
        duration: 1.15,
        ease: "power2.out",
        onUpdate: function () {
          item.textContent = Math.round(state.val).toString();
        },
      });
      return;
    }

    const fragment = document.createDocumentFragment();

    targetText.split("").forEach((char) => {
      const span = document.createElement("span");
      span.textContent = char;
      fragment.appendChild(span);
    });

    item.innerHTML = "";
    item.appendChild(fragment);

    const numberSpans = item.querySelectorAll("span");
    numberSpans.forEach((span, index) => {
      const randomInterval = setInterval(() => {
        span.textContent = getRandomCharacter();
      }, 50);

      setTimeout(
        () => {
          clearInterval(randomInterval);
          span.textContent = targetText[index];
        },
        700 + index * 200,
      );
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumbers(entry.target);
        observer.unobserve(entry.target);
      }
    });
  });

  items.forEach((item) => observer.observe(item));
}

$(document).ready(function () {
  // Set initial animation states before first paint to prevent flash of content
  // if (typeof gsap !== "undefined") {
  //   if (window.innerWidth >= 1199) {
  //     document.querySelectorAll("[data-reveal-trigger]").forEach(function (el) {
  //       gsap.set(el, {
  //         opacity: 0,
  //         y: 50,
  //         visibility: "visible",
  //         force3D: true,
  //         willChange: "transform, opacity",
  //       });
  //     });
  //   }
  //   if (window.innerWidth >= 1200) {
  //     document.querySelectorAll(".wrg.split-text").forEach(function (el) {
  //       gsap.set(el, { y: 25, force3D: true });
  //     });
  //   }
  // }

  // imgToSvg();
  headerSticky();
  current__year();
  accordion__toggle();

  // hamburger__click();
  // newsSlider();
  cursorClick();

  setTimeout(() => {
    // initSplitTextSlideUp();
  }, 150);

  setTimeout(() => {
    initScrollRevealTrigger();
    animateNumberReveal(".js-stat-number-value");
  }, 300);

  window.addEventListener("resize", function () {
    // On mobile: clear any y transform set by initSplitTextSlideUp
    if (window.innerWidth < 1200) {
      document.querySelectorAll(".wrg.split-text").forEach((el) => {
        gsap.set(el, { clearProps: "y" });
      });
    } else {
      setTimeout(() => {
        if (typeof window.initScrollRevealTrigger === "function") {
          window.initScrollRevealTrigger();
        }
      }, 100);
    }
  });
});
